var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._v(" "+_vm._s(_vm.stateSync)+" "),_c('div',{staticClass:"route_part"},[_c('router-view')],1),_c('Internet')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }